// Static audio cache (pre-generated files). All app audio is pre-rendered at
// build time and served as static files; there is no live TTS at runtime.
const staticCache = new Map()
const staticPending = new Map()

/**
 * Prefetch an array of static audio URLs as blobs for instant playback.
 * Deduplicates and silently ignores failures.
 */
export async function prefetchStaticAudio(urls) {
  const unique = [...new Set(urls.filter(Boolean))]

  const promises = unique.map((url) => {
    if (staticCache.has(url)) return Promise.resolve()
    if (staticPending.has(url)) return staticPending.get(url)

    const promise = fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('fetch failed')
        return response.blob()
      })
      .then((blob) => {
        staticCache.set(url, URL.createObjectURL(blob))
        staticPending.delete(url)
      })
      .catch(() => {
        staticPending.delete(url)
      })

    staticPending.set(url, promise)
    return promise
  })

  return Promise.allSettled(promises)
}

/**
 * Get the cached blob URL for a static audio file, or return the original URL.
 */
export function getStaticAudioUrl(url) {
  return staticCache.get(url) || url
}
